import { createContext, useRef, useMemo, createElement, useContext, useState } from 'react';

// https://github.com/reach/reach-ui/blob/2a20f45849220c6bc71f8e7425e3ac4f41cd5a0a/packages/utils/src/lib/Context.js
var defaultPrefix = "id-";

var generateId = function generateId(prefix) {
  if (prefix === void 0) {
    prefix = defaultPrefix;
  }

  return "" + prefix + Math.random().toString(32).substr(2, 6);
};

var Context = createContext(generateId);
function IdProvider(_ref) {
  var children = _ref.children,
      _ref$unstable_prefix = _ref.unstable_prefix,
      prefix = _ref$unstable_prefix === void 0 ? "" : _ref$unstable_prefix;
  var count = useRef(0);
  var genId = useMemo(function () {
    return function (localPrefix) {
      if (localPrefix === void 0) {
        localPrefix = defaultPrefix;
      }

      return "" + prefix + localPrefix + ++count.current;
    };
  }, [prefix]);
  return createElement(Context.Provider, {
    value: genId
  }, children);
}
function useId(prefix) {
  if (prefix === void 0) {
    prefix = defaultPrefix;
  }

  var genId = useContext(Context);

  var _React$useState = useState(function () {
    return genId(prefix);
  }),
      id = _React$useState[0];

  return id;
}

export { IdProvider, useId };
